import { createApp } from "vue";
import router from "@/router";
import { createApplicationInsights } from "@/services/application-insights/application-insight";
import { createGlobalErrorHandlerPlugin } from "./services/application-insights/global-error-handler-plugin";
import App from "@/views/App.vue";
import { createPinia } from "pinia";
import { useUserSettingsStore } from "@/modules/user/settings-store";

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);

const { applicationInsightsPlugin, applicationInsights } =
  createApplicationInsights(router);
app.use(applicationInsightsPlugin);

if (import.meta.env.PROD) {
  app.use(createGlobalErrorHandlerPlugin(), { applicationInsights });
}

const store = useUserSettingsStore();
store.$subscribe(
  (mutation, state) => {
    localStorage.setItem("state-user-settings", JSON.stringify(state));
  },
  { detached: true },
);

app.mount("#app");
